/**
* @file 产品功能
* @author
*/

import React from 'react';
import preAuth from './imgs/call-auth-pre.png';
import aftAuth from './imgs/call-auth-after.png';
import callHistory from './imgs/call-auth-history.png';
import AuthButton from '../attest/authButton';
import ZTag from '../../components/Tag/index';

interface Props {
    title: string;
}
export default function Features(props: Props) {

    return (
        <div className="features">
            <p className="common-title title">{props.title}</p>
            <div className="features-box">
                <p className="features-title">企业电话呼入呼出时，用户手机端展示企业信息</p>
                <div className="features-content">
                    <div className="features-auth-box features-auth-pre">
                        <p>认证前</p>
                        <img width="280" src={preAuth}/>
                        <br/>
                        <ZTag color="error" style={{marginRight: '12px'}}>陌生号码</ZTag>
                        <ZTag color="error">未知信息</ZTag>
                    </div>
                    <span className="features-vs">vs</span>
                    <div className="features-auth-box features-auth-after">
                        <p>认证后</p>
                        <img width="544" src={aftAuth}/>
                        <br/>
                        <ZTag color="success" style={{marginRight: '12px'}}>品牌名称</ZTag>
                        <ZTag color="success">品牌LOGO</ZTag>
                    </div>
                </div>
            </div>
            <div className="features-more">
                <p  className="features-title">企业信息留存至通话记录，方便用户回拨</p>
                <div className="features-more-info">
                    <img className="features-more-img" src={callHistory}/>
                    <div className="features-more-text">
                        <div className="features-more-text-after">
                            <p>认证后</p>
                            <p>官方信息 便于查找</p>
                        </div>
                        <div className="features-more-text-pre">
                            <p>认证前</p>
                            <p>陌生信息 无法查找</p>
                        </div>
                    </div>
                </div>
            </div>
            <AuthButton
                {...props}
                name="了解更多功能"/>
        </div>
    );
}
